/**
 * Retorna o caminho base atual da aplicacao de forma consistente entre
 * ambientes publicados em subpastas diferentes.
 */
export function obterBaseAplicacaoAtual(): string {
  const normalizarBase = (valorBase: string): string => {
    const valorNormalizado = valorBase.trim();
    if (!valorNormalizado || valorNormalizado === '.') {
      return '/';
    }

    if (valorNormalizado === './') {
      if (typeof window === 'undefined') {
        return '/';
      }

      const primeiroSegmentoCaminho = window.location.pathname.split('/').filter(Boolean)[0];
      return primeiroSegmentoCaminho ? `/${primeiroSegmentoCaminho}/` : '/';
    }

    return valorNormalizado.endsWith('/') ? valorNormalizado : `${valorNormalizado}/`;
  };

  const baseConfiguradaAmbiente = import.meta.env.VITE_APP_BASE_PATH;
  if (import.meta.env.DEV && typeof baseConfiguradaAmbiente === 'string' && baseConfiguradaAmbiente.trim().length > 0) {
    return normalizarBase(baseConfiguradaAmbiente);
  }

  const baseConfiguradaVite = import.meta.env.BASE_URL;
  if (typeof baseConfiguradaVite === 'string' && baseConfiguradaVite.trim().length > 0) {
    return normalizarBase(baseConfiguradaVite);
  }

  if (typeof window === 'undefined') {
    return '/';
  }

  const primeiroSegmentoCaminho = window.location.pathname.split('/').filter(Boolean)[0];
  return primeiroSegmentoCaminho ? `/${primeiroSegmentoCaminho}/` : '/';
}
